/**
 * Toucan Music — what the browser calls each page. The joining of the app's
 * name and the page's is the platform's; this file is only about what each
 * route's page is called.
 */

import { documentTitle, listById, required } from "toucan";
import { importTitle } from "./import.ts";
import { albumById, UNSHELVED_LABEL } from "./model.ts";
import type { Route } from "./routes.ts";
import { store } from "./state.ts";

/** What every page's title opens with. */
const APP = "Toucan Music";

/** The browser's title for the page this route shows. */
export function pageTitle(route: Route): string {
  return documentTitle(APP, pageName(route));
}

/**
 * The page's own name, or "" where it has none to add — the library, and a
 * shelf that has been deleted, which is the whole library too.
 */
function pageName(route: Route): string {
  if (route.name === "album") {
    // The shell swaps the route of an album that has gone for the library's
    // (see `shownRoute`), so the album is always there.
    const album = required(albumById(store(), route.id), "album");
    return `${album.name} by ${album.artist}`;
  }
  if (route.name === "shelf") {
    const shelf = listById(store().shelves, route.id);
    return shelf === undefined ? "" : shelf.name;
  }
  if (route.name === "unshelved") {
    return UNSHELVED_LABEL;
  }
  if (route.name === "search") {
    return "Add an album";
  }
  if (route.name === "import") {
    return importTitle(route.source);
  }
  if (route.name === "settings") {
    return "Settings";
  }
  return "";
}
